import { CommonApiEndpoint } from '@core/api-endpoint';
import {
  FetchAttrListByGroupCodePayload,
  FetchAttrListByGroupCodeResponse,
  FetchDetailByComCodePayload,
  FetchDetailByComCodeResponse,
  FetchDetailRegionPayload,
  FetchDetailRegionResponse,
  FetchGroupRegistSettingPayload,
  FetchListByGroupCodePayload,
  FetchListByGroupCodeResponse,
  FetchMainBoardsPayload,
  FetchMainBoardsResponse,
  FetchSystemConfigResponse,
  FetchSystemConfigSimpleResponse,
  FetchSystemInfoResponse,
  RequestCaptchaResponse,
} from '@core/dto';
import { HttpInterface } from '@core/http';
import { useCommonStore } from '@stores';

export class CommonAdapter {
  http: HttpInterface;
  commonStore: any;
  constructor(httpInstance: HttpInterface) {
    this.http = httpInstance;
    this.commonStore = useCommonStore();
  }

  async fetchListByGroupCode(
    payload: FetchListByGroupCodePayload
  ): Promise<FetchListByGroupCodeResponse[]> {
    const { groupCode, useFlag = false } = payload;
    const url = this.http.replacedUrl(CommonApiEndpoint.fetchListByGroupCode, {
      groupCode,
    });
    const response = await this.http.get<FetchListByGroupCodeResponse[]>(url, {
      useFlag,
    });
    this.commonStore.setAreaCodeList(response.data);
    return response.data;
  }

  async fetchDetailRegionList(
    payload: FetchDetailRegionPayload
  ): Promise<FetchDetailRegionResponse[]> {
    const response = await this.http.get<FetchDetailRegionResponse[]>(
      CommonApiEndpoint.fetchDetailRegion,
      payload
    );
    return response.data;
  }

  async fetchGroupRegistSetting(
    payload: FetchGroupRegistSettingPayload
  ): Promise<any> {
    const response = await this.http.get<any>(
      CommonApiEndpoint.fetchGroupRegistSetting,
      payload
    );
    return response.data;
  }

  async fetchSystemInfo(): Promise<FetchSystemInfoResponse> {
    const response = await this.http.get<FetchSystemInfoResponse>(
      CommonApiEndpoint.commonTotalInfo
    );
    return response.data;
  }

  async fetchSystemConfig(): Promise<FetchSystemConfigResponse> {
    const response = await this.http.get<FetchSystemConfigResponse>(
      CommonApiEndpoint.fetchSystemConfig
    );
    return response.data;
  }

  async fetchSystemConfigSimple(): Promise<FetchSystemConfigSimpleResponse[]> {
    const response = await this.http.get<FetchSystemConfigSimpleResponse[]>(
      CommonApiEndpoint.fetchSystemConfigSimple
    );
    return response.data;
  }

  async fetchDetailByComCode(
    payload: FetchDetailByComCodePayload
  ): Promise<FetchDetailByComCodeResponse> {
    const { groupCode, comCode, useFlag = false } = payload;
    const url = this.http.replacedUrl(CommonApiEndpoint.fetchDetailByComCode, {
      groupCode,
      comCode,
    });
    const response = await this.http.get<FetchDetailByComCodeResponse>(url, {
      useFlag,
    });
    return response.data;
  }

  async fetchAttrListByGroupCode(
    payload: FetchAttrListByGroupCodePayload
  ): Promise<FetchAttrListByGroupCodeResponse[]> {
    const { groupCode, comCode, useFlag = false, idx } = payload;
    const url = this.http.replacedUrl(
      CommonApiEndpoint.fetchAttrListByGroupCode,
      {
        groupCode,
      }
    );
    const response = await this.http.get<FetchAttrListByGroupCodeResponse[]>(
      url,
      {
        useFlag,
        idx,
        comCode,
      }
    );
    return response.data;
  }

  async requestCaptcha(): Promise<RequestCaptchaResponse> {
    const response = await this.http.post<RequestCaptchaResponse>(
      CommonApiEndpoint.requestCaptcha
    );
    return response.data;
  }

  async fetchMainBoards(
    payload?: FetchMainBoardsPayload
  ): Promise<FetchMainBoardsResponse> {
    const response = await this.http.get<FetchMainBoardsResponse>(
      CommonApiEndpoint.fetchMainBoards,
      payload || {}
    );
    return response.data;
  }
}
